import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

const { ui } = constants.colors;
const { fontSize } = typographyStyles;

export const dropdownCss: CSSObject = {
  width: "254px",
};

// Necessary to prevent links showing over submenu headers on mobile.
export const anchorCss: CSSObject = {
  position: "unset",
};

export const assignmentAnchorCss: CSSObject = {
  ...anchorCss,
  borderBottom: `1px solid ${ui.neutral[50]}`,
  borderRadius: 0,
};

// Necessary to hide icon.
export const anchorIconCss: CSSObject = {
  display: "none",
};

const iconCss: CSSObject = {
  height: "20px",
  marginRight: "0.5em",
  verticalAlign: "text-bottom",
};

export const assignmentIconCss: CSSObject = {
  display: "inline",
  color: ui.neutral[500],
  ...iconCss,
};

export const lockIconCss = (
  isPrintDisabled: boolean,
  isButtonIcon = false,
) => ({
  display: isPrintDisabled ? "inline" : "none",
  color: isButtonIcon ? "inherit" : ui.neutral[500],
  ...iconCss,
});

export const printItemCss = (isPrintDisabled: boolean) => ({
  "& > a:first-child > div": {
    display: isPrintDisabled ? "flex" : "inherit",
    flexDirection: "row",
    color: isPrintDisabled ? ui.neutral[500] : "inherit",
  },
  ...(isPrintDisabled && {
    a: {
      cursor: "not-allowed",
    },
    "a:hover": {
      backgroundColor: "unset",
    },
  }),
});

export const subscriptionMsgCSS = (isMobile?: boolean | undefined) => ({
  padding: "0.5em 1em 0.1em",
  color: ui.white[700],
  borderRadius: isMobile ? "0" : "4px 4px 0px 0px",
  ...fontSize.textM,
  backgroundColor: ui.core[500],
  "& > h2": {
    marginTop: "0",
    backgroundColor: ui.core[500],
  },
});

export const msgHeadingCss: CSSObject = {
  ...fontSize.textXS,
  textTransform: "uppercase",
};
